import React from 'react'
import Chip from '@mui/material/Chip'
import { StreamingStatus, GcpChannelState, HealthOverallStatus } from '../types'

// ─── Streaming Status ──────────────────────────────────────────────────────────

const STREAMING_STATUS_CONFIG: Record<string, { label: string; color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' }> = {
  created_hiplade:                    { label: 'Criado',               color: 'default' },
  initializing:                       { label: 'Inicializando',        color: 'info' },
  running:                            { label: 'Transmitindo',         color: 'success' },
  processing_recording:               { label: 'Processando gravação', color: 'info' },
  not_corrected:                      { label: 'Gravação disponível',  color: 'warning' },
  force_stopped:                      { label: 'Parado manualmente',   color: 'warning' },
  dismissed:                          { label: 'Descartado',           color: 'default' },
  error_gcp_create_streaming:         { label: 'Erro GCP',             color: 'error' },
  error_gcp_rca:                      { label: 'Erro GCP/RCA',         color: 'error' },
  error_gcp_no_main_camera:           { label: 'Sem câmera principal', color: 'error' },
  error_rca:                          { label: 'Erro RCA',             color: 'error' },
  error_merdiaservice_create_streaming: { label: 'Erro Mediaserver',   color: 'error' },
}

interface StreamingStatusBadgeProps {
  status: StreamingStatus | string
  size?: 'small' | 'medium'
}

export function StreamingStatusBadge({ status, size = 'small' }: StreamingStatusBadgeProps) {
  const config = STREAMING_STATUS_CONFIG[status] ?? { label: status, color: 'default' as const }
  return <Chip label={config.label} color={config.color} size={size} />
}

// ─── GCP Channel State ────────────────────────────────────────────────────────

const GCP_STATE_CONFIG: Record<string, { label: string; color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' }> = {
  STOPPED:  { label: 'Parado',      color: 'default' },
  STARTING: { label: 'Iniciando',   color: 'info' },
  RUNNING:  { label: 'Ativo',       color: 'success' },
  STOPPING: { label: 'Parando',     color: 'warning' },
}

interface GcpChannelStateBadgeProps {
  state: GcpChannelState
  size?: 'small' | 'medium'
}

export function GcpChannelStateBadge({ state, size = 'small' }: GcpChannelStateBadgeProps) {
  if (!state) return <Chip label="—" color="default" size={size} />
  const config = GCP_STATE_CONFIG[state] ?? { label: state, color: 'default' as const }
  return <Chip label={config.label} color={config.color} size={size} />
}

// ─── Health Overall Status ────────────────────────────────────────────────────

const HEALTH_STATUS_CONFIG: Record<HealthOverallStatus, { label: string; color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' }> = {
  ready:     { label: 'Pronto',         color: 'success' },
  warning:   { label: 'Atenção',        color: 'warning' },
  not_ready: { label: 'Não está pronto', color: 'error' },
}

interface HealthStatusBadgeProps {
  status: HealthOverallStatus
  size?: 'small' | 'medium'
}

export function HealthStatusBadge({ status, size = 'small' }: HealthStatusBadgeProps) {
  const config = HEALTH_STATUS_CONFIG[status]
  return <Chip label={config.label} color={config.color} size={size} />
}
